var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPossible2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 70,
    viewBox: "0 0 46 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164140"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 163552",
    transform: "translate(-657.435 -1388.368)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148350",
    width: 16.579,
    height: 16.579,
    rx: 8.289,
    transform: "translate(660.434 1427.264)",
    style: {
      fill: "#ffd133"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148351",
    width: 9.474,
    height: 9.474,
    rx: 4.737,
    transform: "translate(691.224 1398.842)",
    style: {
      fill: "#ffd133"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148353",
    width: 4.737,
    height: 4.737,
    rx: 2.368,
    transform: "translate(660.434 1389.368)",
    style: {
      fill: "#ffd133"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.38 54.583v-5.592a11.563 11.563 0 0 1-6.3-2.23 10.883 10.883 0 0 1-3.68-5.131l1.416-.708a10.832 10.832 0 0 0 3.539 4.778 9.681 9.681 0 0 0 5.875 1.663 12.065 12.065 0 0 0 6.37-1.8 6.178 6.178 0 0 0 2.973-5.7 6.943 6.943 0 0 0-2.23-5.415 21.1 21.1 0 0 0-7.4-3.716 19.606 19.606 0 0 1-7.361-3.751 7.481 7.481 0 0 1-2.265-5.733 7.27 7.27 0 0 1 2.867-5.875 9.968 9.968 0 0 1 6.193-2.407V7.3h1.557v5.663a12.153 12.153 0 0 1 4.675 1.137 9.234 9.234 0 0 1 3.61 3.327l-1.274.849a9.748 9.748 0 0 0-3.079-2.8 8.9 8.9 0 0 0-4.565-1.1 9.863 9.863 0 0 0-5.91 1.8 5.873 5.873 0 0 0-2.513 5.061 6.408 6.408 0 0 0 1.77 4.565q1.77 1.876 7.574 3.716a19.944 19.944 0 0 1 7.5 4.07 8.529 8.529 0 0 1 2.407 6.193 8.057 8.057 0 0 1-2.936 6.419 11.7 11.7 0 0 1-7.255 2.725v5.663z",
    transform: "translate(653.508 1392.728)",
    style: {
      fill: "#191919"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossible2);
export default __webpack_public_path__ + "static/media/possible-2.00752b9f4f280dce878cb303d79294c0.svg";
export { ForwardRef as ReactComponent };